// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Auth from "../../bundles/Auth/Auth.res.js";
import * as Navigation from "../../primitives/Navigation.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as CustomerRoutes from "./CustomerRoutes.res.js";
import * as AccessDeniedPage from "../Error/AccessDeniedPage.res.js";
import * as CustomerFormPage from "./CustomerFormPage.res.js";
import * as CustomerListPage from "./CustomerListPage.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as CustomerDetailsPage from "./CustomerDetailsPage.res.js";
import * as CustomerDetailsLoyaltyHistoryPage from "./CustomerDetailsLoyaltyHistoryPage.res.js";

function CustomerRouter(props) {
  let subUrlPath = props.subUrlPath;
  let url = Navigation.useUrl();
  let userRole = Auth.useRole();
  if (!Auth.isAuthorizedAccess(userRole, CustomerRoutes.baseRoute)) {
    return JsxRuntime.jsx(AccessDeniedPage.make, {});
  }
  if (subUrlPath === 0) {
    return JsxRuntime.jsx(CustomerListPage.make, {});
  }
  let id = subUrlPath.hd;
  let exit = 0;
  if (id === "new" && subUrlPath.tl === 0) {
    let business = Stdlib_Option.getOr(CustomerRoutes.decodeCreateCustomerQueryString(url.query), false);
    return JsxRuntime.jsx(CustomerFormPage.make, {
      mode: "Create",
      customerShowRoute: CustomerRoutes.showRoute,
      customerNewRoute: business => CustomerRoutes.newRoute(business, undefined),
      business: business
    });
  }
  exit = 2;
  if (exit === 2) {
    let match = subUrlPath.tl;
    if (match === 0) {
      return JsxRuntime.jsx(CustomerDetailsPage.make, {
        id: id
      });
    }
    switch (match.hd) {
      case "edit" :
        let match$1 = match.tl;
        if (match$1 === 0) {
          return JsxRuntime.jsx(CustomerFormPage.make, {
            mode: {
              TAG: "Edit",
              id: id,
              section: undefined
            },
            customerShowRoute: CustomerRoutes.showRoute,
            customerNewRoute: business => CustomerRoutes.newRoute(business, undefined),
            suggestedSiret: CustomerRoutes.decodeEditCustomerQueryString(url.query)
          });
        }
        if (match$1.tl === 0) {
          let section = CustomerRoutes.EditSection.fromString(match$1.hd);
          if (section !== undefined) {
            return JsxRuntime.jsx(CustomerFormPage.make, {
              mode: {
                TAG: "Edit",
                id: id,
                section: section
              },
              customerShowRoute: CustomerRoutes.showRoute,
              customerNewRoute: business => CustomerRoutes.newRoute(business, undefined)
            });
          } else {
            return JsxRuntime.jsx(Navigation.Redirect.make, {
              route: CustomerRoutes.editRoute(id, undefined)
            });
          }
        }
        break;
      case "loyalty-history" :
        if (match.tl === 0) {
          return JsxRuntime.jsx(CustomerDetailsLoyaltyHistoryPage.make, {
            id: id
          });
        }
        break;
    }
  }
  return JsxRuntime.jsx(Navigation.Redirect.make, {
    route: CustomerRoutes.baseRoute
  });
}

let make = CustomerRouter;

export {
  make,
}
/* Auth Not a pure module */
